export default __webpack_public_path__ + "static/media/cocktail3.e10c5f18.jpg";